import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import BoxComponent from "../../../../../components/Box/BoxComponent";
import ButtonComponent from "../../../../../components/Button/ButtonComponent";
import { PedidoItemDTO, PedidoUsuarioDTO } from "../../../../../interface/Pedido";
import TypographyComponent from "../../../../../components/Typography/ThypographyComponent";
import { formatNumberToDinheiro } from "../../../../../utils/dinheiro";

interface ModalDetalhesInfoPedidoProps {
    open: boolean;
    pedido?: PedidoUsuarioDTO;
    onClose: () => void;
}

const ModalDetalhesInfoPedidoComponent = (props: ModalDetalhesInfoPedidoProps) => {
    if (props.pedido == null) return;

    return <Dialog open={props.open} onClose={props.onClose} maxWidth={false} sx={{
        display: "flex",
        justifyContent: "center",
        height: "100dvh",
        width: "100vw",
        "& .MuiDialog-container": {
            "& .MuiPaper-root": {
                width: "384px",
            },
        },
    }} fullWidth>
        <DialogTitle
            sx={{
                fontFamily: '"Font 2", sans-serif',
                fontWeight: 700,
                fontSize: '24px',
                lineHeight: '32px',
                letterSpacing: '0%',
                color: '#101828',
                display: 'inline-flex',
                alignItems: 'center',
                verticalAlign: 'middle'
            }}
        >
            Pedido #{props.pedido.id}
        </DialogTitle>

        <DialogContent sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1.5
        }}>
            {/*ITENS DO PEDIDO */}
            <BoxComponent component="section" sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1.5
            }}>
                <TypographyComponent
                    variant="h3"
                    sx={{
                        fontFamily: '"Font 2", sans-serif',
                        fontWeight: 700,
                        fontSize: '24px',
                        lineHeight: '32px',
                        letterSpacing: '0%',
                        color: '#101828',
                        display: 'inline-flex',
                        alignItems: 'center',
                        verticalAlign: 'middle'
                    }}
                >
                    Itens
                </TypographyComponent>
                <BoxComponent component="div"
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 0.5
                    }}>
                    {props.pedido?.itens.map((element: PedidoItemDTO, index: number) => {
                        return <BoxComponent component="article"
                            key={`item-pedido-${index}`}
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                gap: 1.5
                            }}>
                            <TypographyComponent
                                variant="body2"
                                sx={{
                                    fontFamily: '"Font 1", sans-serif',
                                    fontWeight: 400,
                                    fontSize: '14px',
                                    lineHeight: '20px',
                                    letterSpacing: '0%',
                                    color: '#364153',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    verticalAlign: 'middle'
                                }}
                            >
                                {element.qtd}x {element.titulo}
                            </TypographyComponent>
                            <TypographyComponent
                                variant="body2"
                                sx={{
                                    fontFamily: '"Font 1", sans-serif',
                                    fontWeight: 600,
                                    fontSize: '14px',
                                    lineHeight: '20px',
                                    letterSpacing: '0%',
                                    color: '#101828',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    verticalAlign: 'middle'
                                }}
                            >
                                {formatNumberToDinheiro(element.vlrTotal)}
                            </TypographyComponent>
                        </BoxComponent>
                    })}
                </BoxComponent>
            </BoxComponent>

            {/*FORMA DE PAGAMENTO DO PEDIDO */}
            <BoxComponent component="section" sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1.5
            }}>
                <TypographyComponent
                    variant="h3"
                    sx={{
                        fontFamily: '"Font 2", sans-serif',
                        fontWeight: 700,
                        fontSize: '24px',
                        lineHeight: '32px',
                        letterSpacing: '0%',
                        color: '#101828',
                        display: 'inline-flex',
                        alignItems: 'center',
                        verticalAlign: 'middle'
                    }}
                >
                    Forma de pagamento
                </TypographyComponent>

                <TypographyComponent
                    variant="body2"
                    sx={{
                        fontFamily: '"Font 1", sans-serif',
                        fontWeight: 400,
                        fontSize: '14px',
                        lineHeight: '20px',
                        letterSpacing: '0%',
                        color: '#4A5565',
                        textTransform: 'capitalize',
                        display: 'inline-flex',
                        alignItems: 'center',
                        verticalAlign: 'middle'
                    }}
                >
                    {props.pedido.formaPgto}
                </TypographyComponent>
            </BoxComponent>
        </DialogContent>

        <DialogActions sx={{
            display: "flex",
            justifyContent: "center"
        }}>
            <ButtonComponent
                id="close_modal_item_pedido" onClick={props.onClose}
                sx={{
                    height: '42px',
                    display: 'flex',
                    alignItems: 'center',
                    boxSizing: 'border-box',
                    borderRadius: '8px',
                    border: '1px solid #E0E0E0',
                    padding: '8px 16px', // Conforme sua especificação (top/bottom e right/left)
                    opacity: 1,
                    backgroundColor: '#FFFFFF',
                    // Estilos de texto baseados nos padrões que definimos antes
                    fontFamily: '"Font 7", sans-serif',
                    fontSize: '14px',
                    color: '#333333',
                    textTransform: "initial",
                    width: "100%"
                }}
            >
                Fechar
            </ButtonComponent>
        </DialogActions>
    </Dialog >
}

export default ModalDetalhesInfoPedidoComponent;